export default __webpack_public_path__ + "static/media/notification.368541c4.svg";